import { FaBars } from 'react-icons/fa';
import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';
  
export const Nav = styled.nav`
  background: #FFFFFF;
  height: 85px;
  display: flex;
  justify-content: space-between;
  padding: 0rem 2rem;
  z-index: 12;
  /* Third Nav */
  /* justify-content: flex-start; */
`;
export const NavLink = styled(Link)`
  color: #000000;
  display: flex;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  &.active {
    color: #ffc000;
  }
  &:hover {
    transition: all 0.2s ease-in-out;
    color: #ffc000;
  }
`;
  
export const Bars = styled(FaBars)`
  display: none;
  color: #808080;
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;
  
export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -24px;
  /* Second Nav */
  /* margin-right: 24px; */
  /* Third Nav */
  /* width: 100vw;
  white-space: nowrap; */
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
  
export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  /* Third Nav */
  /* justify-content: flex-end;
  width: 100vw; */
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const NavText = styled.h1`
  margin-top: 1.6rem;
  font-family: 'Times New Roman', Times, serif; 
  font-size: 30px;
`;
export const NavBtnLink = styled(Link)`
  font-family: 'Times New Roman', Times, serif;
  border-radius: 4px;
  background: #052825;
  padding: 10px 22px;
  color: #FFFFFF;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  /* Second Nav */
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #808080;
  }
`;